import React from "react";
import { Col, Row } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import Logo from "../../assets/imgs/logo-eg.svg";
import PortalCliente from '../../assets/imgs/logos/2025/PortaldoCliente.svg';
import AlumisoftBr from '../../assets/imgs/logos/2025/alumisoft_branco.svg';
import EPrefBr from '../../assets/imgs/logos/2025/preference_branco.svg';
import FaktoryBr from '../../assets/imgs/logos/2025/faktory_branco.svg';
import BtnCompany from "./components/btnCompany";
import './style.css';

const SelectionCompany : React.FC = () => {

    return(
        <>
            <div className="page-main p-1">
                <div className="content p-4">
                    <Row className="rowComp">
                        <Col xl={5} lg={5} md={3} sm={3} xs={3} className="colImg">
                            <img src={PortalCliente} className="imgPC"/>
                        </Col>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1} className="colComp">
                            <hr/>
                        </Col>
                        <Col xl={6} lg={6} md={7} sm={7} xs={7} className="colTitle">
                            <h1>Acesse o portal da <br/><strong className="empresa">empresa desejada</strong></h1>
                        </Col>
                    </Row>
                    <Row className="justify-content-center py-5">
                        <Col xl={3} lg={2} md={3} sm={3} xs={12} className="colComp p-3">
                            <BtnCompany path={"/Alumisoft/Login"} className={"btn-alumisoft"} src={AlumisoftBr}/>
                        </Col>
                        <Col xl={3} lg={2} md={3} sm={3} xs={12} className="colComp p-3">
                            <BtnCompany  path={"/Preference"} className={"btnEpref"} src={EPrefBr}/>
                        </Col>
                        <Col xl={3} lg={2} md={3} sm={3} xs={12} className="colComp p-3">
                            <a href="https://faktory.com.br/correcoes-e-solucoes/" >
                                <button className="shadow btn btnFaktory">
                                <img src={FaktoryBr} className="p-3"/>
                                    <p className="p-1 teste">
                                        Acesse
                                        <BsArrowRight className="ml-2"/>
                                    </p>  
                                </button>
                            </a>
                        </Col>
                    </Row>
                    <Row className="rowComp">                           
                        <Col xl={5} lg={6} md={8} sm={10} xs={12} className="colComp p-4">
                            <img src={Logo} className="imgEsquadGroup"/>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
 )};

export default SelectionCompany;